// CTA hotspot → modal renderer.

import type { CtaConfig, CtaHotspot, Room } from '../app/types';
import type { ModalRoot } from './modal';
import { getAnalytics } from '../playcanvas/analytics';

/** Shown when neither the hotspot nor the config supplies copy. */
const FALLBACK_MESSAGE = 'Fale com nossa equipe para saber mais sobre este imóvel.';

export function openCtaModal(
  modal: ModalRoot,
  hotspot: CtaHotspot,
  room: Room,
  // Optional: Demo Studio omits the whole `cta` block until an admin writes
  // the copy, so a portal-authored tour can reach here with nothing set.
  ctaConfig: CtaConfig | undefined,
): void {
  const message = hotspot.description ?? ctaConfig?.defaultMessage ?? FALLBACK_MESSAGE;
  const url = hotspot.ctaUrl ?? ctaConfig?.contactUrl;
  modal.open({
    id: `cta:${hotspot.id}`,
    title: hotspot.label,
    bodyHtml: `
      <p>${escapeHtml(message)}</p>
      <p style="font-size:12px;color:var(--dim);margin-top:-4px;">Ambiente: <strong>${escapeHtml(room.name)}</strong></p>
    `,
    actions: [
      {
        label: hotspot.ctaLabel,
        primary: true,
        url,
        onClick: () => getAnalytics().log('cta_clicked', { hotspot: hotspot.id, room: room.id, url }),
      },
      { label: 'Fechar' },
    ],
  });
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
